module.exports = __webpack_public_path__ + "img/at.8dc68995.svg";